import type { TSourceCaptionElement } from '@alpod-ai-writer/plate-plugins/source-caption';
import { cn } from '@udecode/cn';
import { PlateElement, withRef } from '@udecode/plate/react';

export const SourceCaptionElement = withRef<
  typeof PlateElement,
  {}
>(({ children, className, ...props }, ref) => {
    const element = props.element as TSourceCaptionElement;
    const { align } = element;

    return (
        <PlateElement
            ref={ref}
            as='p'
            className={cn(
                className,
                'border border-gray-300 border-dashed p-1 rounded-md text-sm',
                'mb-4',
                align === 'left' && 'text-left justify-start',
                align === 'center' && 'text-center justify-center',
                align === 'right' && 'text-right justify-end',
                align === 'justify' && 'text-justify justify-start'
            )}
            {...props}
        >

            <span className='inline-block p-0.5'>
                {children}
            </span>
        </PlateElement>
    );
});
